import React from 'react';
import { addonsWithMultipleValues } from '@shootsta/addons-summarizer';
import { getCostForAddon } from '../utils';
import { SUPERSIZE_MY_EDIT_LABELS } from './supersizeMyEditAddons';

const icon = 'extrafootage';

export default function () {
  return ({
    billingEntityCode,
    addonsCosts



  }) => (type) => {
    const SUPERSIZE_MY_EDIT_OPTIONS = Object.keys(SUPERSIZE_MY_EDIT_LABELS).
    map((option) => {
      const cost = getCostForAddon({ costs: addonsCosts[type].costs, billingEntityCode });
      const isMultiple = option && addonsWithMultipleValues.includes(option);

      return {
        label: SUPERSIZE_MY_EDIT_LABELS[option],
        value: option,
        suffix: <span>{cost}</span>,
        description: '',
        isMultiple,
        cost,
        icon
      };
    });

    return SUPERSIZE_MY_EDIT_OPTIONS;
  };
}